import { AVAILABLE_LANGS, useI18n, type Lang } from "../i18n";

const LABELS: Record<Lang, string> = { en: "EN", uk: "УКР" };

export default function LanguageToggle({ className = "" }: { className?: string }) {
  const { lang, setLang } = useI18n();
  // Nothing to switch between while only one language is offered
  if (AVAILABLE_LANGS.length < 2) return null;
  return (
    <div className={`inline-flex items-center ${className}`}>
      {AVAILABLE_LANGS.map((l) => (
        <button
          key={l}
          type="button"
          onClick={() => setLang(l)}
          className={`min-h-[44px] rounded-full px-3 text-xs transition-colors ${
            lang === l
              ? "font-semibold text-charcoal"
              : "text-charcoal-muted hover:text-charcoal"
          }`}
          aria-pressed={lang === l}
        >
          {LABELS[l]}
        </button>
      ))}
    </div>
  );
}
